import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormButtons from '../../components/FormButtons';
import InputPhone from '../../components/InputPhone';
import InputText from '../../components/InputText';
import Select from '../../components/Select';
import useFields from '../../hooks/useFields';
import { formatValuesLoad } from '../index/values';
import { FormSituacionFam } from './styled';
import Checkbox from '@/presentation/reusables/Checkbox';
import IDHelpers from '@/core/helpers/IDHelper';

interface FamilyFormProps {
  idRequest: number;
  save: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  next: () => void;
}

interface CheckboxState {
  [key: string]: boolean;
}

export const validateCaseIsIncomplete = (fieldsFamily: any) => {
  if (
    fieldsFamily.familySituation !== '' &&
    fieldsFamily.dataResponsable !== '' &&
    fieldsFamily.responsibleWorkSituation !== ''
  ) {
    return true;
  }

  return false;
};

const FamilyForm = (props: FamilyFormProps) => {
  const { idRequest, next, save } = props;
  const [validateForm, setValidateForm] = useState(0);
  const formBse = useSelector((state: any) => state.getFormBse);
  const { formFamily } = formatValuesLoad(formBse?.data);
  const { fields, setFieldValue, setFieldError, formIsEmpty } = useFields(
    formFamily || {}
  );

  if (!formBse?.data) return null;

  const {
    familySituation,
    nameFamiliar1,
    dniFamiliar1,
    phoneFamiliar1,
    nameFamiliar2,
    dniFamiliar2,
    phoneFamiliar2,
    dataResponsable,
    dependents,
    relationshipFamiliar1,
    relationshipFamiliar2,
    responsibleWorkSituation
  } = fields;

  const validateCaseEmptyIncomplete = (fieldsFamilyData: any) => {
    delete fieldsFamilyData?.padresApoderados;
    return !(
      fieldsFamilyData.dataResponsable ||
      fieldsFamilyData.responsibleWorkSituation ||
      fieldsFamilyData.fullNameFather ||
      fieldsFamilyData.dniFather ||
      fieldsFamilyData.phoneFather ||
      fieldsFamilyData.fullNameMother ||
      fieldsFamilyData.dniMother ||
      fieldsFamilyData.phoneMother ||
      fieldsFamilyData.fullNameRepresentative ||
      fieldsFamilyData.dniRepresentative ||
      fieldsFamilyData.phoneRepresentative ||
      fieldsFamilyData.numberBrothers ||
      fieldsFamilyData.familySituation ||
      fieldsFamilyData.dependents
    );
  };

  const saveForm = () => {
    setValidateForm(validateForm + 1);
    save('family', fields, validateCaseIsIncomplete(fields), true);
  };

  const [checkboxes, setCheckboxes] = useState<CheckboxState>({
    Padre: false,
    Madre: false,
    Conyugue: false,
    Hijos: false,
    'Otros familiares': false,
    Ninguno: false
  });

  useEffect(() => {
    const updateCheckboxes = () => {
      // Dividir el string dependents en un array
      const dependentsArray = dependents.split(',');

      // Crear un nuevo objeto de estado basado en el string dependents
      const newCheckboxes = { ...checkboxes };

      Object.keys(newCheckboxes).forEach((checkbox) => {
        if (dependentsArray.includes(checkbox)) {
          newCheckboxes[checkbox] = true;
        } else {
          newCheckboxes[checkbox] = false;
        }
      });

      // Actualizar el estado de los checkboxes
      setCheckboxes(newCheckboxes);
    };

    updateCheckboxes();
  }, [dependents]);

  const handleCheckboxChange = (checkbox: string) => {
    setCheckboxes((prevCheckboxes) => {
      const updatedCheckboxes = {
        ...prevCheckboxes,
        [checkbox]: !prevCheckboxes[checkbox]
      };
      const selectedOptions = Object.keys(updatedCheckboxes).filter(
        (checkboxItem) => updatedCheckboxes[checkboxItem]
      );
      const selectedOptionsString = selectedOptions.join(',');
      setFieldValue({
        name: 'dependents',
        value: selectedOptionsString
      });
      return updatedCheckboxes;
    });
  };

  React.useEffect(() => {
    if (idRequest > 0 && !formIsEmpty) {
      save('family', fields, validateCaseIsIncomplete(fields), false);
    }
  }, [idRequest, formIsEmpty]);

  return (
    <div style={{ padding: '16px 24px' }}>
      <div>
        <Select
          nameLabel="¿Cuál es tu dependencia económica?"
          value={dataResponsable}
          name="dataResponsable"
          optionsList={formBse?.data?.[73]?.dropDownList}
          placeholder="selecciona tu situación"
          setFieldValue={setFieldValue}
          validateOnStart={
            idRequest
              ? idRequest > 0 && !validateCaseEmptyIncomplete(fields)
              : false
          }
          validateForm={validateForm}
        />
        {(dataResponsable === '57' ||
          dataResponsable === '58' ||
          dataResponsable === '60' ||
          dataResponsable === '61') && (
          <div
            style={{
              padding: '12px',
              borderRadius: '8px',
              gap: '16px',
              background: '#ECF4F9',
              marginBottom: '8px'
            }}
          >
            <div
              style={{
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                letterSpacing: '0px',
                textAlign: 'left',
                color: ' #161D1F'
              }}
            >
              Ingresa los datos del primer familiar
            </div>
            <div
              style={{
                color: '#5B36F2',
                paddingBottom: '16px'
              }}
            >
              (Estos datos son opcionales)
            </div>
            <Select
              nameLabel=""
              value={relationshipFamiliar1}
              name="relationshipFamiliar1"
              optionsList={[
                {
                  id: 'Padre',
                  description: 'Padre'
                },
                {
                  id: 'Madre',
                  description: 'Madre'
                },
                {
                  id: 'Apoderado',
                  description: 'Apoderado'
                },
                {
                  id: 'Conyugue',
                  description: 'Conyugue'
                },
                {
                  id: 'Otro familiar directo',
                  description: 'Otro familiar directo'
                }
              ].filter((item) => item.id !== relationshipFamiliar2)}
              placeholder="Selecciona el parentesco"
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
            />
            <InputText
              name="nameFamiliar1"
              placeholder="Nombres y apellidos completos"
              value={nameFamiliar1}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
              showCount={false}
            />
            <InputText
              name="dniFamiliar1"
              placeholder="Documento de identidad"
              value={dniFamiliar1}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
              showCount={false}
            />
            <InputPhone
              name="phoneFamiliar1"
              placeholder="Ingresa tu número telefónico"
              value={phoneFamiliar1}
              maxLength={9}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
            />
          </div>
        )}
        {(dataResponsable === '57' || dataResponsable === '61') && (
          <div
            style={{
              padding: '12px',
              borderRadius: '8px',
              gap: '16px',
              background: '#ECF4F9',
              marginBottom: '8px'
            }}
          >
            <div
              style={{
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                letterSpacing: '0px',
                textAlign: 'left',
                color: ' #161D1F'
              }}
            >
              Ingresa los datos del segundo familiar
            </div>
            <div
              style={{
                color: '#5B36F2',
                paddingBottom: '16px'
              }}
            >
              (Estos datos son opcionales)
            </div>
            <Select
              nameLabel=""
              value={relationshipFamiliar2}
              name="relationshipFamiliar2"
              optionsList={[
                {
                  id: 'Padre',
                  description: 'Padre'
                },
                {
                  id: 'Madre',
                  description: 'Madre'
                },
                {
                  id: 'Apoderado',
                  description: 'Apoderado'
                },
                {
                  id: 'Conyugue',
                  description: 'Conyugue'
                },
                {
                  id: 'Otro familiar directo',
                  description: 'Otro familiar directo'
                }
              ].filter((item) => item.id !== relationshipFamiliar1)}
              placeholder="Selecciona el parentesco"
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
            />
            <InputText
              name="nameFamiliar2"
              placeholder="Nombres y apellidos completos"
              value={nameFamiliar2}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
              showCount={false}
            />
            <InputText
              name="dniFamiliar2"
              placeholder="Documento de identidad"
              value={dniFamiliar2}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
              showCount={false}
            />
            <InputPhone
              name="phoneFamiliar2"
              placeholder="Ingresa tu número telefónico"
              value={phoneFamiliar2}
              maxLength={9}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              validateOnStart={false}
              validateForm={0}
            />
          </div>
        )}

        <div
          style={{
            marginBottom: '24px'
          }}
        >
          <div
            style={{
              fontSize: '14px',
              fontWeight: '700',
              lineHeight: '20px',
              letterSpacing: '0px',
              textAlign: 'left',
              marginBottom: '24px',
              color: '#161d1f'
            }}
          >
            ¿Quiénes depende económicamente de ti?
          </div>
          {Object.keys(checkboxes).map((checkbox) => (
            <Checkbox
              key={IDHelpers.generateID()}
              label={checkbox}
              checked={checkboxes[checkbox]}
              onChange={() => handleCheckboxChange(checkbox)}
            />
          ))}
        </div>

        <FormSituacionFam>
          <Select
            nameLabel="¿Cuál es la situación laboral actual del responsable de los pagos de la universidad?"
            // isQuestionBold
            value={responsibleWorkSituation}
            name="responsibleWorkSituation"
            optionsList={formBse?.data?.[76]?.dropDownList}
            placeholder="selecciona tu situación"
            setFieldValue={setFieldValue}
            validateOnStart={
              idRequest
                ? idRequest > 0 && !validateCaseEmptyIncomplete(fields)
                : false
            }
            // validateOnStart={idRequest ? idRequest > 0 : false}
            validateForm={validateForm}
            top
          />
        </FormSituacionFam>
        <FormSituacionFam>
          <Select
            nameLabel="¿Cuál es tu situación familiar actualmente?"
            // isQuestionBold
            value={familySituation}
            name="familySituation"
            optionsList={formBse?.data?.[75]?.dropDownList}
            placeholder="selecciona tu situación"
            setFieldValue={setFieldValue}
            validateOnStart={
              idRequest
                ? idRequest > 0 && !validateCaseEmptyIncomplete(fields)
                : false
            }
            // validateOnStart={idRequest ? idRequest > 0 : false}
            validateForm={validateForm}
            top
          />
        </FormSituacionFam>
        <FormButtons
          handlerSend={saveForm}
          handlerNext={next}
          formIsValid={!validateCaseEmptyIncomplete(fields)}
        />
      </div>
    </div>
  );
};

export default FamilyForm;
